import { render, staticRenderFns } from "./ProductDetailAccordionCreate.vue?vue&type=template&id=1b5c5e8e&"
import script from "./ProductDetailAccordionCreate.vue?vue&type=script&lang=js&"
export * from "./ProductDetailAccordionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports